import { useEffect, useState } from "react";
import SimCardRechargeStyle from "./SimCardRechargeStyle";
import { Helmet } from "react-helmet";
import Box from "../../../components/box/Box";
import axios from "../../../components/plugins/axios";
import {getBahabinText, toPersianNumber} from "../../../util/DominantUtil";
import SimChargePaymentModal from "../../../components/payment/SimChargePaymentModal";
import { getOperatorBgColor, getOperatorEnName, getProduct, operatorsPrefix } from "../../../components/payment/util";


function getType(operator) {
    if (operator === 'ایرانسل') {
        return ''
    } else if (operator === 'همراه اول') {
        return '1'
    } else if (operator === 'رایتل') {
        return '2';
    }
    return '';

}

export default function SimCardReCharge(response) {
    const [packages, setPackages] = useState(null);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [price, setPrice] = useState(null);
    const [operator, setOperator] = useState(null);
    const [pType, setPType] = useState("عادی");
    const [isSpecialPackage, setIsSpecialPackage] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setPackages(getPackages());
    }, [])

    useEffect(() => {
        setPrice(null);
    }, [operator])

    function getPackages() {
        axios
            .get("/sim-charge-packages").then((response) => {
                setPackages(response.data)
            }).catch((error) => {
                console.log(error)
            });
    }

    function getOperator(opFaName) {
        return <div className="col-sm-3" onClick={() => setOperator(opFaName)}>
            <div className={`operator bg-gray-300 h-14 w-14 rounded-custom mx-auto ${getOperatorEnName(opFaName)}`}
                style={{ backgroundColor: operator === opFaName ? getOperatorBgColor(operator) : '' }}>
                <img src={`/images/sim-card-recharge/${getOperatorEnName(opFaName)}.png`} alt="Irancel" />
            </div>
            <p className={`text-center text-sm pt-0.5 ${operator === opFaName ? '' : 'text-gray-500'}`}>{opFaName}</p>
        </div>;
    }

    function getCard(idx, p) {
        return <div className="col p-0 card-box">
            <div
                className={`h-14 py-2.5 rounded-custom price-box mb-1.5 mt-0 ${idx % 2 === 0 && 'ml-1.5'} 
                    ${price === p && 'price-box-selected'}`}
                onClick={() => {
                    setPrice(p)
                }}>
                <div className="pt-1">
                    <span className="text-lg">{toPersianNumber(p.toLocaleString())}</span>
                    <span className="text-xs pr-1">ریال</span>
                </div>
            </div>
        </div>;
    }

    return (
        <Box rwFreeHeight={true} disableHeader={true} loaded={true} leftBoxClassName={'w-100 pt-4'}
            disableAdBox={true}
             linksMap={{
                 'last': 'شارژ',
             }}>
            <Helmet
                title={`خرید شارژ ایرانسل، همراه اول و رایتل ${getBahabinText()}`}
            />
            <h1 className="text-center text-xl">شارژ اعتباری ایرانسل، همراه اول و رایتل</h1>
            <div>
                <div className="container-fluid">
                    <div className="row justify-content-center md:pr-1 pt-4">
                        <div className="col-sm m-1 box-shadow bg-white rounded-custom p-4 mb-2">
                            <div className="row row-cols-2 rounded-custom">
                                <label className="col-2 col-form-label mt-2 text-right">شماره:</label>
                                <div className="col-10">
                                    <input autoFocus placeholder="09xxxxxxxxx" type="number" maxLength={11}
                                        className="form-control h-14 rounded-custom text-left" onChange={(val) => {
                                            let v = val.target.value;
                                            const reg = /^09[0-9]{9}$/;
                                            if (reg.test(v))
                                                setMobileNumber(v);

                                            const prefix = v.substr(0, 4);
                                            operatorsPrefix.forEach(x => {
                                                const data = new Set(x.items);
                                                if (data.has(prefix)) {
                                                    setOperator(x.operator);
                                                }
                                            });
                                            // operatorsPrefix[operator].contain(prefix);
                                        }} />
                                </div>
                            </div>
                            <div className="row row-cols-3 pt-4 justify-content-center">
                                {getOperator('ایرانسل')}
                                {getOperator('همراه اول')}
                                {getOperator('رایتل')}
                            </div>
                            {/*<div className="row row-cols-2 pt-4">*/}
                            {/*    <div className="col-8 text-right">*/}
                            {/*        <p>شارژ شگفت انگیز</p>*/}
                            {/*        <span className="text-gray-400">تا 25% هدیه شارژ بیشتر نسبت به مبلغ اصلی</span>*/}
                            {/*    </div>*/}
                            {/*    <div className="col-4 text-left">*/}
                            {/*        <Switch*/}
                            {/*            checked={isSpecialPackage}*/}
                            {/*            onChange={() => setIsSpecialPackage(!isSpecialPackage)}*/}
                            {/*            height={20}*/}
                            {/*            width={50}*/}
                            {/*            onColor="#03A9F4"*/}
                            {/*            onHandleColor="#017BB0"*/}
                            {/*            handleDiameter={26}*/}
                            {/*            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"*/}
                            {/*            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"*/}
                            {/*            uncheckedIcon={''}*/}
                            {/*            checkedIcon={''}*/}
                            {/*        />*/}
                            {/*    </div>*/}

                            {/*</div>*/}
                        </div>
                        <div className="col-sm m-1">
                            <div className="row row-cols-2 justify-content-center text-center">
                                {operator && packages && packages
                                    .filter(p => p.operator === operator)
                                    .map(x => x.kind)
                                    .flatMap(x => x)
                                    .filter(x => x.name === pType)
                                    .map(p => p.items)
                                    .flatMap(p => p)
                                    .map((p, idx) => getCard(idx, p))
                                }
                                <div className="h-14" />
                            </div>
                            {price && mobileNumber && operator &&
                                <div className="row justify-content-center h-14">
                                    <button className="h-auto w-100 btn btn-success rounded-custom text-lg buy-btn"
                                        onClick={() => setShowModal(true)}>
                                        خرید
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {price && mobileNumber && operator && showModal &&
                    <SimChargePaymentModal show={showModal} onHide={() => setShowModal(false)} operator={operator}
                        mobileNumber={mobileNumber}
                        type={getType(operator)}
                        price={price} onClick={() => setShowModal(false)} enName={getOperatorEnName(operator)}
                        product={getProduct(operator)} />
                }
            </div>
            <SimCardRechargeStyle />
        </Box>
    );
}